export const nav = [
  {
    logogreen: "./Images/logo/green/Navbar_Green_Logo_Default.svg",
    logowhite: "./Images/logo/white/Navbar_White_Logo.svg",
  },
];
